export const FeedbackType = {
  DOCUMENT_REVIEW: 'DOCUMENT_REVIEW',
} as const;

export const AutoResolutionType = {
  REMINDER: 'REMINDER',
  AUTO_CANCEL: 'AUTO_CANCEL',
  AUTO_APPROVAL: 'AUTO_APPROVAL',
  UNKNOWN: 'UNKNOWN',
} as const;

export const FeedbackGroupState = {
  AWAITING_FEEDBACK: 'AWAITING_FEEDBACK',
  FEEDBACK_SUBMITTED: 'FEEDBACK_SUBMITTED',
} as const;

export const FeedbackSubmissionStatus = {
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
} as const;

/**
 * The list of customer feedback group states that our application cares about.
 * We can include this list in our request to ORCA to act as a filter so that it only
 * returns groups in the states that we wish to process.
 */

export const customerFeedbackGroupStatesFilter = [
  FeedbackGroupState.AWAITING_FEEDBACK,
];

/**
 * The list of customer feedback requests types that our application cares about.
 * We can include this list in our request to ORCA to act as a filter so that it only
 * returns the type of requests that we wish to process.
 */
export const customerFeedbackTypesFilter = [FeedbackType.DOCUMENT_REVIEW];
